
import React, { useState } from "react";
import "./Academics.css";
import Navbar from "../Homepage/Navbar/Navbar";
import Footer from "../Homepage/Footer/Footer";

const Academics = () => {
  const [activeTab, setActiveTab] = useState("about");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <Navbar />

      <section className="academics-page">
        <div className="academics-container">

          {/* Mobile Toggle */}
          <button
            className="academics-mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            ☰ Academics Menu
          </button>

          {/* Sidebar */}
          <aside className={`academics-sidebar ${mobileOpen ? "open" : ""}`}>
            <h3 className="academics-title">Academic Affairs</h3>

            <nav className="academics-sidebar-nav">
              <button className={activeTab==="about"?"active":""} onClick={() => {setActiveTab("about"); setMobileOpen(false);}}>About Academics</button>
              <button className={activeTab==="programmes"?"active":""} onClick={() => {setActiveTab("programmes"); setMobileOpen(false);}}>Programmes Offered</button>
              <button className={activeTab==="engineering"?"active":""} onClick={() => {setActiveTab("engineering"); setMobileOpen(false);}}>Engineering Syllabus</button>
              <button className={activeTab==="degree"?"active":""} onClick={() => {setActiveTab("degree"); setMobileOpen(false);}}>Degree Syllabus</button>
              <button className={activeTab==="pg"?"active":""} onClick={() => {setActiveTab("pg"); setMobileOpen(false);}}>PG Syllabus</button>
            </nav>
          </aside>

          {/* Content */}
          <main className="academics-content">
            {activeTab === "about" && <AboutAcademics />}
            {activeTab === "programmes" && <Programmes />}
            {activeTab === "engineering" && <Engineering />}
            {activeTab === "degree" && <Degree />}
            {activeTab === "pg" && <PG />}
          </main>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default Academics;

/* ================= SECTIONS ================= */

const AboutAcademics = () => (
  <>
    <h2 className="academics-heading">About Academic Affairs</h2>

    <div className="academics-dean-section">
      <div className="academics-dean-card">
        <img src="/physics/cvkredd.JPG" alt="Dean" />
        <div>
          <h3>Prof. C. V. Krishna Reddy</h3>
          <p><b>Dean of Academic Affairs</b></p>
          <p>Rayalaseema University, Kurnool</p>
          <p>Email: <a href="mailto:reddycvk02@yahoo.co.in">reddycvk02@yahoo.co.in</a></p>
          <p>Phone: 9989642920</p>
        </div>
      </div>
    </div>

    <p className="academics-text">
      The Academic Affairs Division of Rayalaseema University plans, organizes and monitors
      all academic activities of the University in accordance with UGC, APSCHE and Government norms.
    </p>

    <p className="academics-text">
      The division coordinates curriculum design, syllabus revisions, examinations,
      evaluations and academic quality assurance.
    </p>

    <div className="academics-highlights">
      <h4>Key Functions</h4>
      <ul>
        <li>UG, PG and Research Programme design</li>
        <li>Curriculum and syllabus revisions</li>
        <li>Academic calendar monitoring</li>
        <li>Examinations and evaluations</li>
        <li>Digital learning platforms</li>
        <li>Academic quality assurance</li>
      </ul>
    </div>
  </>
);

const Programmes = () => (
  <>
    <h2 className="academics-heading">Programmes Offered</h2>

    <div className="academics-programmes-grid">
      <div className="academics-programme-card">
        <h4>Undergraduate</h4>
        <ul>
          <li>B.Sc Computer Science</li>
          <li>B.Com Computer Applications</li>
          <li>B.Sc Horticulture</li>
        </ul>
      </div>

      <div className="academics-programme-card">
        <h4>Engineering</h4>
        <ul>
          <li>B.Tech CSE</li>
          <li>B.Tech AI</li>
          <li>B.Tech ECE</li>
          <li>B.Tech Civil</li>
          <li>B.Tech Mechanical</li>
        </ul>
      </div>

      <div className="academics-programme-card">
        <h4>Postgraduate</h4>
        <ul>
          <li>M.Sc Biotechnology</li>
           <li>M.Sc Botany</li>
           <li>M.B.A</li>
           <li>M.Sc Chemistry</li>
           <li>M.Com</li>
           <li>M.C.A</li>
           <li>M.Sc Computer Science</li>
           <li>M.A English</li>
           <li>M.A Economics</li>
           <li>M.Sc Food Science and Nutrition</li>
           <li>M.Sc Mathematics</li>
           <li>M.Sc OR & SQC (Statistics)</li>
           <li>M.Sc Physics</li>
           <li>M.A Telugu</li>
           <li>M.Sc Zoology</li>
        </ul>
      </div>
    </div>
  </>
);

const Engineering = () => (
  <>
    <h2 className="academics-heading">Engineering Syllabus</h2>
    <ul className="academics-syllabus">
      <li>
       B.Tech Computer Science & Engineering (CSE)
       <a href="/syllabus/engineering/btech-cse.pdf" download>
         Download PDF
       </a>
     </li>
     <li>
       B.Tech Artificial Intelligence (AI)
       <a href="/syllabus/engineering/btech-ai.pdf" download>
         Download PDF
       </a>
     </li>
     <li>
       B.Tech Electronics & Communication Engineering (ECE)
       <a href="/syllabus/engineering/btech-ece.pdf" download>
         Download PDF
       </a>
     </li>
     <li>
       B.Tech Civil Engineering
       <a href="/syllabus/engineering/btech-civil.pdf" download>
         Download PDF
       </a>
     </li>
     <li>
       B.Tech Mechanical Engineering
       <a href="/syllabus/engineering/btech-mechanical.pdf" download>
         Download PDF
       </a>
     </li>
    </ul>
  </>
);

const Degree = () => (
  <>
    <h2 className="academics-heading">UG Syllabus</h2>
    <ul className="academics-syllabus">
      <li>
       B.Sc Computer Science
       <a href="/syllabus/ug/bsc-computer-science.pdf" download>
         Download PDF
       </a>
     </li>

     <li>
       B.Com Computer Application
       <a href="/syllabus/ug/bcom-computer-application.pdf" download>
         Download PDF
       </a>
     </li>

     <li>
       B.Sc Horticulture
       <a href="/syllabus/ug/bsc-horticulture.pdf" download>
         Download PDF
       </a>
      </li>
    </ul>
  </>
);

const PG = () => (
  <>
    <h2 className="academics-heading">PG Syllabus</h2>
    <ul className="academics-syllabus">
      
    
      <li>
        M.Sc Biotechnology
        <a href="/syllabus/pg/msc-biotechnology.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Botany
        <a href="/syllabus/pg/msc-botany.pdf" download>Download PDF</a>
      </li>
      <li>
        M.B.A
        <a href="/syllabus/pg/mba.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Chemistry
        <a href="/syllabus/pg/msc-chemistry.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Com
        <a href="/syllabus/pg/mcom.pdf" download>Download PDF</a>
      </li>
      <li>
        M.C.A
        <a href="/syllabus/pg/mca.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Computer Science
        <a href="/syllabus/pg/msc-computer-science.pdf" download>Download PDF</a>
      </li>
      <li>
        M.A English
        <a href="/syllabus/pg/ma-english.pdf" download>Download PDF</a>
      </li>
      <li>
        M.A Economics
        <a href="/syllabus/pg/ma-economics.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Food Science and Nutrition
        <a href="/syllabus/pg/msc-food-science-nutrition.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Mathematics
        <a href="/syllabus/pg/msc-mathematics.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc OR & SQC (Statistics)
        <a href="/syllabus/pg/msc-or-sqc.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Physics
        <a href="/syllabus/pg/msc-physics.pdf" download>Download PDF</a>
      </li>
      <li>
        M.A Telugu
        <a href="/syllabus/pg/ma-telugu.pdf" download>Download PDF</a>
      </li>
      <li>
        M.Sc Zoology
        <a href="/syllabus/pg/msc-zoology.pdf" download>Download PDF</a>
      </li>
  
    </ul>
  </>
);

